@for (keyValuePair of populatedDataSet | iterable; track keyValuePair.key) {
  <div class="chart-row is-lab-color-space">
    @if (keyValuePair.value.colorSet.length === 0) {
      <p class="chart-empty">
        {{ keyValuePair.key }}: {{ 'dashboard.missingData' | translate }}
      </p>
    }
    @if (keyValuePair.value.colorSet.length > 0) {
      <colimo-canvas-wrapper
        [chartType]="keyValuePair.key"
        [quadrant]="keyValuePair.value.chQuadrant"
        ngClass="is-lpg-right"
        >
        <div class="chart-inner-wrapper">
          @for (boxplot of keyValuePair.value.colorSet; track i; let i = $index) {
            <div
              class="boxplot-wrapper"
              [ngClass]="{ 'is-hidden': !boxplot.display, 'is-visible': boxplot.display }"
              >
              <div class="type-label">{{ keyValuePair.key | labelByChartType: dataSet.tolerances }}</div>
              <colimo-lpg-chart-component
                [boxplotChild]="boxplot"
                [iterationIndex]="i"
                [key]="keyValuePair.key"
                [angles]="lineChartAngles"
              ></colimo-lpg-chart-component>
            </div>
          }
        </div>
      </colimo-canvas-wrapper>
    }
  </div>
}

@if (isLoading) {
  <colimo-loader [background]="'transparent'" [top]="'40%'"></colimo-loader>
}
